import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  userData: {},
};
export const UserDataSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    userResponse: (state, action) => {
      return {
        ...state,
        userData: action.payload,
      };
    },
  },
});
export const { userResponse } = UserDataSlice.actions;
export default UserDataSlice.reducer;
